export default {
  speaker_event: [],
  events: [],
  speakers: [],
  statistics: {},
}
